import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import cardData from './cardData.json';
import './HomePage.css';
import CarouselSection from './CarouselSection';
import ProcessSection from './ProcessSection';
import InvestorTwinsSection from './InvestorTwinsSection';
import BytheNumbersSection from './BytheNumbersSection';
import ServicesSection from './ServicesSection'; 
import WhyUseSection from './WhyUseSection'; 
import ContactSection from './ContactSection';

function HomePage({ userState, setUserState }) {
  const navigate = useNavigate();
  const packagesRef = useRef(null);

  const startSession = (packageAssistantId, voiceName) => {
    setUserState({
      ...userState,
      agentId: packageAssistantId,
      voiceName: voiceName
    });
    navigate(`/therapy-session`);
  };

  const scrollToPackages = () => {
    packagesRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <CarouselSection scrollToPackages={scrollToPackages} />
      <BytheNumbersSection />
      <ServicesSection />
      <ProcessSection scrollToPackages={scrollToPackages} />
      <WhyUseSection />
      <ContactSection />
    </>
  );
}

export default HomePage;
